import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Pin: React.FC<Props> = ({ accessibilityLabel, className }) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <circle cx={12} cy={10} r={2} stroke='currentColor' strokeWidth='1.5' />
      <path
        d='M18 10c0 3.314-6 10-6 10s-6-6.686-6-10a6 6 0 1112 0z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    </svg>
  </i>
);

Pin.displayName = 'Pin';
export default Pin;
